export default ['api', '$rootScope', function(api, $rootScope) {
  return {
    collectOptions: (data) => {
      return api.post('/options', data).
        then(response => response.data);
    },
    collectExtras: (data) => {
      return api.post('/extras', data).
        then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/services/optionExtras.service.js